<script>
import GenresList from '@components/genre/genres-list'

export default {
    components: { GenresList },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

<template>
    <div class="list">
        <div
            v-for="(item, index) in items"
            :key="`recent-${item.id && item.id}${index}`"
            :class="[
                'list-item',
                item.type === 'genre' && 'list-item-genre',
                item.type === 'artist' && 'list-item-artist',
            ]"
        >
            <div
                v-if="item.type !== 'genre'"
                class="list-tile"
            >
                <BaseLink :to="{ name: item.type, params: { id: item.id } }">
                    <BaseResourceImage
                        :resource="item.type === 'mix' ? item.episode : item"
                        class="image"
                        :type="item.type === 'artist' ? 'photo' : 'album_art'"
                    />
                </BaseLink>
                <div>
                    <BaseLink :to="{ name: item.type, params: { id: item.id } }">
                        <div class="title">
                            {{ item.type === 'mix' ? item.show.title : item.title }}
                        </div>
                    </BaseLink>
                    <div class="subtitle">
                        {{ item.type }}
                    </div>
                </div>
            </div>
            <div
                v-else
                class="list-tile"
            >
                <GenresList :genres="[item.title]" />
                <div class="subtitle">
                    {{ item.type }}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.list {
    margin-bottom: $s-m * 4;
}

.list-tile {
    display: grid;
    grid-template-columns: 64px 100%;
    column-gap: $s-m;
    align-items: center;
}

.image {
    @include square(64px);

    overflow: hidden;
}

.subtitle {
    @extend %contentSubtitleM;

    text-transform: capitalize;
}

.list-item {
    &-artist {
        .image {
            border-radius: 50%;
        }
    }
    &-genre {
        .list-tile {
            grid-template-columns: max-content auto;
            column-gap: 0;
            text-transform: capitalize;
        }
        .subtitle {
            margin-bottom: $s-m;
        }
    }
}

.list-item ~ .list-item {
    margin-top: $s-m * 2;
}

.title {
    @extend %contentTitleM;
}
</style>
